import { StatusIncidentUpdate } from '@portal-core/status-incidents/models/status-incident-update.model';

/**
 * Orders updates oldest-first by CreatedOn, the meaningful "when did this happen"
 * key, with Id as a tiebreaker for updates created in the same tick. Shared by
 * sortStatusIncidentUpdates (UI, reversed to newest-first) and the
 * chronological markdown export (used as-is).
 */
export function compareStatusIncidentUpdatesByCreatedOn(update1: StatusIncidentUpdate, update2: StatusIncidentUpdate): number {
  const update1Time = update1.CreatedOn ? new Date(update1.CreatedOn).getTime() : 0;
  const update2Time = update2.CreatedOn ? new Date(update2.CreatedOn).getTime() : 0;
  return update1Time !== update2Time ? update1Time - update2Time : update1.Id - update2.Id;
}

/**
 * Filters out deleted updates and sorts the rest newest-first. Used by UI surfaces
 * (dialogs, banner, history grid) that show "latest status" at a glance, in
 * contrast to the export's oldest-first, read-top-to-bottom timeline.
 */
export function sortStatusIncidentUpdates(updates: StatusIncidentUpdate[] | undefined | null): StatusIncidentUpdate[] {
  if (!updates) {
    return [];
  }
  return updates
    .filter(update => !update.IsDeleted)
    .sort((update1, update2) => -compareStatusIncidentUpdatesByCreatedOn(update1, update2));
}

/** Returns the most recent non-deleted update, or null if there are none. */
export function findLatestStatusIncidentUpdate(updates: StatusIncidentUpdate[] | undefined | null): StatusIncidentUpdate | null {
  return sortStatusIncidentUpdates(updates)[0] ?? null;
}
